<template>
    <div class="row">
        <div class="col-xs-12">
            <flCabecalhoForm
                :msg="_traducao('global', 'obrigatorio')"
                cls="print-titulo-form-20"
                :texto="_traducao('global','controleHorasOvn')"
            />
        </div>
        <div class="container-fluid conteudo">
            <div class="row">
                <div class="col-xs-3">
                    <label>
                        {{ _traducao('global','horasVooUsuarioOvn') }}:
                        <i 
                            class="fa fa-info-circle"
                            v-tooltip="_traducao('global','infoHorasOvn')"
                        >
                        </i>
                    </label>
                    <money
                        v-model="form.horas_voo_ovn"
                        class="form-control input-sm"
                        v-bind="_vpercem(1)"
                    >
                    </money>
                </div>
                <div class="col-xs-3">
                    <label>{{ _traducao('global','dataUltimoVoo') }}:</label>
                    <flDateTime
                    @v-model="(val) => (form.data_ultimo_voo_ovn = val)"
                    :value="form.data_ultimo_voo_ovn"
                    :format="_formatDate"
                    :lang="_getLangDp"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    horas_voo_ovn: '',
                    data_ultimo_voo_ovn: ''
                }
            }
        },
        methods: {
            editar(item) {
                this.form.horas_voo_ovn = item.horas_voo_ovn
                this.form.data_ultimo_voo_ovn = item.data_ultimo_voo_ovn
            },

            validaForm() {
                this.$emit('dados-ovn', this.form)
            }
        }
    }
</script>